import "src/web/ab_lipstick/feel_great/home"

require.context("../../../src/web/images", true)
